import { apiPost, apiDelete } from "../api_helper"

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - base64String.length % 4) % 4)
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/")
  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}

export const PushManager = {
  async isSupported() {
    return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window
  },

  async isSubscribed() {
    if (!await this.isSupported()) return false
    const reg = await navigator.serviceWorker.ready
    const sub = await reg.pushManager.getSubscription()
    return !!sub
  },

  async subscribe() {
    if (!await this.isSupported()) return false

    const permission = await Notification.requestPermission()
    if (permission !== "granted") return false

    try {
      const reg = await navigator.serviceWorker.ready
      const vapidPublicKey = window.VAPID_PUBLIC_KEY
      if (!vapidPublicKey) {
        console.warn("VAPID public key not configured")
        return false
      }

      const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidPublicKey)
      })

      const json = sub.toJSON()
      await apiPost("/api/push_subscriptions", {
        endpoint: json.endpoint,
        keys: {
          p256dh: json.keys.p256dh,
          auth: json.keys.auth
        }
      })

      return true
    } catch (e) {
      console.error("Push subscribe error:", e)
      return false
    }
  },

  async unsubscribe() {
    try {
      const reg = await navigator.serviceWorker.ready
      const sub = await reg.pushManager.getSubscription()
      if (sub) {
        await apiDelete(`/api/push_subscriptions?endpoint=${encodeURIComponent(sub.endpoint)}`)
        await sub.unsubscribe()
      }
    } catch (e) {
      console.error("Push unsubscribe error:", e)
    }
  }
}
